
import { importSync as i, macroCondition, getGlobalConfig } from '@embroider/macros';
let w = window;
let d = w.define;


i("./-embroider-implicit-modules.js");

d("my-phorest/app", function(){ return i("my-phorest/app.js");});
d("my-phorest/config/environment", function(){ return i("my-phorest/config/environment.js");});
d("my-phorest/decorators/cache-for", function(){ return i("my-phorest/decorators/cache-for.js");});
d("my-phorest/decorators/calculate-balance-change", function(){ return i("my-phorest/decorators/calculate-balance-change.js");});
d("my-phorest/decorators/on-error-code", function(){ return i("my-phorest/decorators/on-error-code.js");});
d("my-phorest/decorators/permission", function(){ return i("my-phorest/decorators/permission.js");});
d("my-phorest/formats", function(){ return i("my-phorest/formats.js");});
d("my-phorest/initializers/extract-mirage-autostart-from-url-hash", function(){ return i("my-phorest/initializers/extract-mirage-autostart-from-url-hash.js");});
d("my-phorest/instance-initializers/electron-init", function(){ return i("my-phorest/instance-initializers/electron-init.js");});
d("my-phorest/instance-initializers/yup-init", function(){ return i("my-phorest/instance-initializers/yup-init.js");});
d("my-phorest/router", function(){ return i("my-phorest/router.js");});
d("my-phorest/sentry", function(){ return i("my-phorest/sentry.js");});
d("my-phorest/services/access", function(){ return i("my-phorest/services/access.js");});
d("my-phorest/services/apollo-cache", function(){ return i("my-phorest/services/apollo-cache.js");});
d("my-phorest/services/apollo-subscriptions", function(){ return i("my-phorest/services/apollo-subscriptions.js");});
d("my-phorest/services/apollo", function(){ return i("my-phorest/services/apollo.js");});
d("my-phorest/services/appointment-branch-settings", function(){ return i("my-phorest/services/appointment-branch-settings.js");});
d("my-phorest/services/appointment-issues", function(){ return i("my-phorest/services/appointment-issues.js");});
d("my-phorest/services/appointment-planner", function(){ return i("my-phorest/services/appointment-planner.js");});
d("my-phorest/services/appointment-prompts", function(){ return i("my-phorest/services/appointment-prompts.js");});
d("my-phorest/services/appointment-slide-over", function(){ return i("my-phorest/services/appointment-slide-over.js");});
d("my-phorest/services/appointment-tasks", function(){ return i("my-phorest/services/appointment-tasks.js");});
d("my-phorest/services/auto-logout", function(){ return i("my-phorest/services/auto-logout.js");});
d("my-phorest/services/background-tasks", function(){ return i("my-phorest/services/background-tasks.js");});
d("my-phorest/services/booking-history", function(){ return i("my-phorest/services/booking-history.js");});
d("my-phorest/services/branch-opening-hours", function(){ return i("my-phorest/services/branch-opening-hours.js");});
d("my-phorest/services/branch-override", function(){ return i("my-phorest/services/branch-override.js");});
d("my-phorest/services/branch-settings", function(){ return i("my-phorest/services/branch-settings.js");});
d("my-phorest/services/branch-time", function(){ return i("my-phorest/services/branch-time.js");});
d("my-phorest/services/break-slide-over", function(){ return i("my-phorest/services/break-slide-over.js");});
d("my-phorest/services/bulk-import", function(){ return i("my-phorest/services/bulk-import.js");});
d("my-phorest/services/calendar-slot-hover", function(){ return i("my-phorest/services/calendar-slot-hover.js");});
d("my-phorest/services/canny", function(){ return i("my-phorest/services/canny.js");});
d("my-phorest/services/cash-counter-slide-over", function(){ return i("my-phorest/services/cash-counter-slide-over.js");});
d("my-phorest/services/cash-up-report", function(){ return i("my-phorest/services/cash-up-report.js");});
d("my-phorest/services/cash-up-slide-over", function(){ return i("my-phorest/services/cash-up-slide-over.js");});
d("my-phorest/services/chain-service-group-item-slide-over", function(){ return i("my-phorest/services/chain-service-group-item-slide-over.js");});
d("my-phorest/services/client-recurring-subscription-service", function(){ return i("my-phorest/services/client-recurring-subscription-service.js");});
d("my-phorest/services/client-search", function(){ return i("my-phorest/services/client-search.js");});
d("my-phorest/services/client-travel-card-printer", function(){ return i("my-phorest/services/client-travel-card-printer.js");});
d("my-phorest/services/clock-in-out", function(){ return i("my-phorest/services/clock-in-out.js");});
d("my-phorest/services/columns-printer", function(){ return i("my-phorest/services/columns-printer.js");});
d("my-phorest/services/commission-brackets-slide-over", function(){ return i("my-phorest/services/commission-brackets-slide-over.js");});
d("my-phorest/services/commission-settings", function(){ return i("my-phorest/services/commission-settings.js");});
d("my-phorest/services/confirm-dialog", function(){ return i("my-phorest/services/confirm-dialog.js");});
d("my-phorest/services/create-treat-card-modal", function(){ return i("my-phorest/services/create-treat-card-modal.js");});
d("my-phorest/services/currency-formatter", function(){ return i("my-phorest/services/currency-formatter.js");});
d("my-phorest/services/data-fetch-manager", function(){ return i("my-phorest/services/data-fetch-manager.js");});
d("my-phorest/services/day-and-time-periods-slide-over", function(){ return i("my-phorest/services/day-and-time-periods-slide-over.js");});
d("my-phorest/services/delete-cashup-modal", function(){ return i("my-phorest/services/delete-cashup-modal.js");});
d("my-phorest/services/discard-changes", function(){ return i("my-phorest/services/discard-changes.js");});
d("my-phorest/services/electron-app-printer", function(){ return i("my-phorest/services/electron-app-printer.js");});
d("my-phorest/services/electron-app", function(){ return i("my-phorest/services/electron-app.js");});
d("my-phorest/services/embedded-app", function(){ return i("my-phorest/services/embedded-app.js");});
d("my-phorest/services/embedded-redirections", function(){ return i("my-phorest/services/embedded-redirections.js");});
d("my-phorest/services/error-handler", function(){ return i("my-phorest/services/error-handler.js");});
d("my-phorest/services/event-propagator", function(){ return i("my-phorest/services/event-propagator.js");});
d("my-phorest/services/facebook", function(){ return i("my-phorest/services/facebook.js");});
d("my-phorest/services/fbe-login", function(){ return i("my-phorest/services/fbe-login.js");});
d("my-phorest/services/full-calendar", function(){ return i("my-phorest/services/full-calendar.js");});
d("my-phorest/services/group-booking", function(){ return i("my-phorest/services/group-booking.js");});
d("my-phorest/services/internet", function(){ return i("my-phorest/services/internet.js");});
d("my-phorest/services/intl", function(){ return i("my-phorest/services/intl.js");});
d("my-phorest/services/keypad", function(){ return i("my-phorest/services/keypad.js");});
d("my-phorest/services/lead-notifications", function(){ return i("my-phorest/services/lead-notifications.js");});
d("my-phorest/services/legacy-reports", function(){ return i("my-phorest/services/legacy-reports.js");});
d("my-phorest/services/local-settings", function(){ return i("my-phorest/services/local-settings.js");});
d("my-phorest/services/loyalty-rewards", function(){ return i("my-phorest/services/loyalty-rewards.js");});
d("my-phorest/services/marketing-consent-modal", function(){ return i("my-phorest/services/marketing-consent-modal.js");});
d("my-phorest/services/meta-ads", function(){ return i("my-phorest/services/meta-ads.js");});
d("my-phorest/services/meta-error-handler", function(){ return i("my-phorest/services/meta-error-handler.js");});
d("my-phorest/services/notifications", function(){ return i("my-phorest/services/notifications.js");});
d("my-phorest/services/now-indicator", function(){ return i("my-phorest/services/now-indicator.js");});
d("my-phorest/services/online-reputation", function(){ return i("my-phorest/services/online-reputation.js");});
d("my-phorest/services/package-tasks", function(){ return i("my-phorest/services/package-tasks.js");});
d("my-phorest/services/patch-test-slide-over", function(){ return i("my-phorest/services/patch-test-slide-over.js");});
d("my-phorest/services/payment-slide-over", function(){ return i("my-phorest/services/payment-slide-over.js");});
d("my-phorest/services/pendo", function(){ return i("my-phorest/services/pendo.js");});
d("my-phorest/services/percentage-formatter", function(){ return i("my-phorest/services/percentage-formatter.js");});
d("my-phorest/services/performance", function(){ return i("my-phorest/services/performance.js");});
d("my-phorest/services/persist-gap-time", function(){ return i("my-phorest/services/persist-gap-time.js");});
d("my-phorest/services/petty-cash-slide-over", function(){ return i("my-phorest/services/petty-cash-slide-over.js");});
d("my-phorest/services/petty-cash-transactions", function(){ return i("my-phorest/services/petty-cash-transactions.js");});
d("my-phorest/services/platform", function(){ return i("my-phorest/services/platform.js");});
d("my-phorest/services/popper", function(){ return i("my-phorest/services/popper.js");});
d("my-phorest/services/printer-setup", function(){ return i("my-phorest/services/printer-setup.js");});
d("my-phorest/services/printing-devices", function(){ return i("my-phorest/services/printing-devices.js");});
d("my-phorest/services/purchase-basket-slide-over", function(){ return i("my-phorest/services/purchase-basket-slide-over.js");});
d("my-phorest/services/purchase-basket", function(){ return i("my-phorest/services/purchase-basket.js");});
d("my-phorest/services/purchase-origin", function(){ return i("my-phorest/services/purchase-origin.js");});
d("my-phorest/services/purchase-receipt-voucher", function(){ return i("my-phorest/services/purchase-receipt-voucher.js");});
d("my-phorest/services/purchase-receipt", function(){ return i("my-phorest/services/purchase-receipt.js");});
d("my-phorest/services/purchase", function(){ return i("my-phorest/services/purchase.js");});
d("my-phorest/services/receipt-settings", function(){ return i("my-phorest/services/receipt-settings.js");});
d("my-phorest/services/recent-clients", function(){ return i("my-phorest/services/recent-clients.js");});
d("my-phorest/services/remove-recurrent-break-modal", function(){ return i("my-phorest/services/remove-recurrent-break-modal.js");});
d("my-phorest/services/reuse-basket", function(){ return i("my-phorest/services/reuse-basket.js");});
d("my-phorest/services/reviewable-tickets", function(){ return i("my-phorest/services/reviewable-tickets.js");});
d("my-phorest/services/revision-key", function(){ return i("my-phorest/services/revision-key.js");});
d("my-phorest/services/route-history", function(){ return i("my-phorest/services/route-history.js");});
d("my-phorest/services/scan-treat-card-modal", function(){ return i("my-phorest/services/scan-treat-card-modal.js");});
d("my-phorest/services/scheduling-provider", function(){ return i("my-phorest/services/scheduling-provider.js");});
d("my-phorest/services/selected-note-printer", function(){ return i("my-phorest/services/selected-note-printer.js");});
d("my-phorest/services/service-group-item-slide-over", function(){ return i("my-phorest/services/service-group-item-slide-over.js");});
d("my-phorest/services/session", function(){ return i("my-phorest/services/session.js");});
d("my-phorest/services/sidebar", function(){ return i("my-phorest/services/sidebar.js");});
d("my-phorest/services/spellchecker", function(){ return i("my-phorest/services/spellchecker.js");});
d("my-phorest/services/staff-category-prices-slide-over", function(){ return i("my-phorest/services/staff-category-prices-slide-over.js");});
d("my-phorest/services/supplier-contact-slide-over", function(){ return i("my-phorest/services/supplier-contact-slide-over.js");});
d("my-phorest/services/swing-bridge", function(){ return i("my-phorest/services/swing-bridge.js");});
d("my-phorest/services/table-editing", function(){ return i("my-phorest/services/table-editing.js");});
d("my-phorest/services/table-reordering", function(){ return i("my-phorest/services/table-reordering.js");});
d("my-phorest/services/table-selection", function(){ return i("my-phorest/services/table-selection.js");});
d("my-phorest/services/tag-manager", function(){ return i("my-phorest/services/tag-manager.js");});
d("my-phorest/services/terminal-loader", function(){ return i("my-phorest/services/terminal-loader.js");});
d("my-phorest/services/terminal-payment", function(){ return i("my-phorest/services/terminal-payment.js");});
d("my-phorest/services/text-input-dialog", function(){ return i("my-phorest/services/text-input-dialog.js");});
d("my-phorest/services/till-balance", function(){ return i("my-phorest/services/till-balance.js");});
d("my-phorest/services/till-loader", function(){ return i("my-phorest/services/till-loader.js");});
d("my-phorest/services/till-sessions", function(){ return i("my-phorest/services/till-sessions.js");});
d("my-phorest/services/timers", function(){ return i("my-phorest/services/timers.js");});
d("my-phorest/services/tooltip", function(){ return i("my-phorest/services/tooltip.js");});
d("my-phorest/services/transaction-slide-over", function(){ return i("my-phorest/services/transaction-slide-over.js");});
d("my-phorest/services/two-way-chat", function(){ return i("my-phorest/services/two-way-chat.js");});
d("my-phorest/services/update-appointments", function(){ return i("my-phorest/services/update-appointments.js");});
d("my-phorest/services/user-idleness", function(){ return i("my-phorest/services/user-idleness.js");});
d("my-phorest/services/version-tracker", function(){ return i("my-phorest/services/version-tracker.js");});
d("my-phorest/services/voucher-receipt", function(){ return i("my-phorest/services/voucher-receipt.js");});
d("my-phorest/services/voucher-selector", function(){ return i("my-phorest/services/voucher-selector.js");});
d("my-phorest/services/whatsapp", function(){ return i("my-phorest/services/whatsapp.js");});
d("my-phorest/services/working-hours-indicators", function(){ return i("my-phorest/services/working-hours-indicators.js");});
d("my-phorest/services/zendesk", function(){ return i("my-phorest/services/zendesk.js");});
d("my-phorest/utils/abort-route-change", function(){ return i("my-phorest/utils/abort-route-change.js");});
d("my-phorest/utils/actions-history", function(){ return i("my-phorest/utils/actions-history.js");});
d("my-phorest/utils/app-version", function(){ return i("my-phorest/utils/app-version.js");});
d("my-phorest/utils/archived-policy", function(){ return i("my-phorest/utils/archived-policy.js");});
d("my-phorest/utils/array", function(){ return i("my-phorest/utils/array.js");});
d("my-phorest/utils/auth", function(){ return i("my-phorest/utils/auth.js");});
d("my-phorest/utils/breakpoints", function(){ return i("my-phorest/utils/breakpoints.js");});
d("my-phorest/utils/browser-agent", function(){ return i("my-phorest/utils/browser-agent.js");});
d("my-phorest/utils/button-icon-helpers", function(){ return i("my-phorest/utils/button-icon-helpers.js");});
d("my-phorest/utils/calendar-cache", function(){ return i("my-phorest/utils/calendar-cache.js");});
d("my-phorest/utils/calendar-events", function(){ return i("my-phorest/utils/calendar-events.js");});
d("my-phorest/utils/calendar", function(){ return i("my-phorest/utils/calendar.js");});
d("my-phorest/utils/checkout", function(){ return i("my-phorest/utils/checkout.js");});
d("my-phorest/utils/client-creation", function(){ return i("my-phorest/utils/client-creation.js");});
d("my-phorest/utils/client-credit-account-balance", function(){ return i("my-phorest/utils/client-credit-account-balance.js");});
d("my-phorest/utils/color", function(){ return i("my-phorest/utils/color.js");});
d("my-phorest/utils/compare-semver", function(){ return i("my-phorest/utils/compare-semver.js");});
d("my-phorest/utils/currency-code", function(){ return i("my-phorest/utils/currency-code.js");});
d("my-phorest/utils/currency", function(){ return i("my-phorest/utils/currency.js");});
d("my-phorest/utils/decimal-symbol-by-locale", function(){ return i("my-phorest/utils/decimal-symbol-by-locale.js");});
d("my-phorest/utils/discounts", function(){ return i("my-phorest/utils/discounts.js");});
d("my-phorest/utils/distance-units", function(){ return i("my-phorest/utils/distance-units.js");});
d("my-phorest/utils/email-valid", function(){ return i("my-phorest/utils/email-valid.js");});
d("my-phorest/utils/enums/fetch-policy", function(){ return i("my-phorest/utils/enums/fetch-policy.js");});
d("my-phorest/utils/enums/payment-types", function(){ return i("my-phorest/utils/enums/payment-types.js");});
d("my-phorest/utils/extract-id-from-api-ref", function(){ return i("my-phorest/utils/extract-id-from-api-ref.js");});
d("my-phorest/utils/gender-utils", function(){ return i("my-phorest/utils/gender-utils.js");});
d("my-phorest/utils/graphql", function(){ return i("my-phorest/utils/graphql.js");});
d("my-phorest/utils/group-by-first-letter", function(){ return i("my-phorest/utils/group-by-first-letter.js");});
d("my-phorest/utils/intl", function(){ return i("my-phorest/utils/intl.js");});
d("my-phorest/utils/is-transition-for-printview", function(){ return i("my-phorest/utils/is-transition-for-printview.js");});
d("my-phorest/utils/is-valid-float", function(){ return i("my-phorest/utils/is-valid-float.js");});
d("my-phorest/utils/jasper-reports", function(){ return i("my-phorest/utils/jasper-reports.js");});
d("my-phorest/utils/local-date-helpers", function(){ return i("my-phorest/utils/local-date-helpers.js");});
d("my-phorest/utils/local-datetime-helpers", function(){ return i("my-phorest/utils/local-datetime-helpers.js");});
d("my-phorest/utils/local-time-helpers", function(){ return i("my-phorest/utils/local-time-helpers.js");});
d("my-phorest/utils/locale-convert", function(){ return i("my-phorest/utils/locale-convert.js");});
d("my-phorest/utils/mask-value", function(){ return i("my-phorest/utils/mask-value.js");});
d("my-phorest/utils/membership-benefits", function(){ return i("my-phorest/utils/membership-benefits.js");});
d("my-phorest/utils/object", function(){ return i("my-phorest/utils/object.js");});
d("my-phorest/utils/packages", function(){ return i("my-phorest/utils/packages.js");});
d("my-phorest/utils/payment-balance", function(){ return i("my-phorest/utils/payment-balance.js");});
d("my-phorest/utils/phone-formatters", function(){ return i("my-phorest/utils/phone-formatters.js");});
d("my-phorest/utils/pick-props", function(){ return i("my-phorest/utils/pick-props.js");});
d("my-phorest/utils/planner", function(){ return i("my-phorest/utils/planner.js");});
d("my-phorest/utils/polyfills", function(){ return i("my-phorest/utils/polyfills.js");});
d("my-phorest/utils/purchase-helpers", function(){ return i("my-phorest/utils/purchase-helpers.js");});
d("my-phorest/utils/quick-client-creation", function(){ return i("my-phorest/utils/quick-client-creation.js");});
d("my-phorest/utils/rectify-zero-hour-time", function(){ return i("my-phorest/utils/rectify-zero-hour-time.js");});
d("my-phorest/utils/recurrence", function(){ return i("my-phorest/utils/recurrence.js");});
d("my-phorest/utils/report-request", function(){ return i("my-phorest/utils/report-request.js");});
d("my-phorest/utils/rewards", function(){ return i("my-phorest/utils/rewards.js");});
d("my-phorest/utils/safe-clone", function(){ return i("my-phorest/utils/safe-clone.js");});
d("my-phorest/utils/sanitize", function(){ return i("my-phorest/utils/sanitize.js");});
d("my-phorest/utils/service-groups", function(){ return i("my-phorest/utils/service-groups.js");});
d("my-phorest/utils/sort-appointments", function(){ return i("my-phorest/utils/sort-appointments.js");});
d("my-phorest/utils/staff-member-tips", function(){ return i("my-phorest/utils/staff-member-tips.js");});
d("my-phorest/utils/staff-member", function(){ return i("my-phorest/utils/staff-member.js");});
d("my-phorest/utils/supported-meta-currency", function(){ return i("my-phorest/utils/supported-meta-currency.js");});
d("my-phorest/utils/text-settings", function(){ return i("my-phorest/utils/text-settings.js");});
d("my-phorest/utils/till-session-helpers", function(){ return i("my-phorest/utils/till-session-helpers.js");});
d("my-phorest/utils/time-conversions", function(){ return i("my-phorest/utils/time-conversions.js");});
d("my-phorest/utils/timeout-for-env", function(){ return i("my-phorest/utils/timeout-for-env.js");});
d("my-phorest/utils/tinymce", function(){ return i("my-phorest/utils/tinymce.js");});
d("my-phorest/utils/track-props", function(){ return i("my-phorest/utils/track-props.js");});
d("my-phorest/utils/value-from-path", function(){ return i("my-phorest/utils/value-from-path.js");});
d("my-phorest/utils/week-start-day", function(){ return i("my-phorest/utils/week-start-day.js");});
d("my-phorest/utils/whatsapp", function(){ return i("my-phorest/utils/whatsapp.js");});
d("my-phorest/instance-initializers/phone-input", function(){ return i("my-phorest/instance-initializers/phone-input.js");});
d("my-phorest/services/phone-input", function(){ return i("my-phorest/services/phone-input.js");});
d("my-phorest/models/consultation-schema-group", function(){ return i("my-phorest/models/consultation-schema-group.js");});
d("my-phorest/models/consultation-schema-item", function(){ return i("my-phorest/models/consultation-schema-item.js");});
d("my-phorest/models/consultation-schema-section", function(){ return i("my-phorest/models/consultation-schema-section.js");});
d("my-phorest/models/consultation-schema", function(){ return i("my-phorest/models/consultation-schema.js");});
d("my-phorest/utils/schema-validator", function(){ return i("my-phorest/utils/schema-validator.js");});
d("my-phorest/services/browser/document", function(){ return i("my-phorest/services/browser/document.js");});
d("my-phorest/services/browser/local-storage", function(){ return i("my-phorest/services/browser/local-storage.js");});
d("my-phorest/services/browser/navigator", function(){ return i("my-phorest/services/browser/navigator.js");});
d("my-phorest/services/browser/session-storage", function(){ return i("my-phorest/services/browser/session-storage.js");});
d("my-phorest/services/browser/window", function(){ return i("my-phorest/services/browser/window.js");});
d("my-phorest/services/keyboard", function(){ return i("my-phorest/services/keyboard.js");});
d("my-phorest/services/page-title", function(){ return i("my-phorest/services/page-title.js");});
d("my-phorest/services/ember-sortable-internal-state", function(){ return i("my-phorest/services/ember-sortable-internal-state.js");});
d("my-phorest/component-managers/glimmer", function(){ return i("my-phorest/component-managers/glimmer.js");});
d("my-phorest/instance-initializers/sentry-performance", function(){ return i("my-phorest/instance-initializers/sentry-performance.js");});
d("my-phorest/initializers/app-version", function(){ return i("my-phorest/initializers/app-version.js");});
d("my-phorest/utils/titleize", function(){ return i("my-phorest/utils/titleize.js");});
d("my-phorest/services/-ensure-registered", function(){ return i("my-phorest/services/-ensure-registered.js");});
d("my-phorest/services/dialog-stack-provider", function(){ return i("my-phorest/services/dialog-stack-provider.js");});
d("my-phorest/instance-initializers/global-ref-cleanup", function(){ return i("my-phorest/instance-initializers/global-ref-cleanup.js");});
d("my-phorest/container-debug-adapter", function(){ return i("my-phorest/container-debug-adapter.js");});
d("my-phorest/templates/accounts", function(){ return i("my-phorest/templates/accounts.hbs");});
d("my-phorest/routes/accounts", function(){ return i("my-phorest/routes/accounts.js");});
d("my-phorest/templates/accounts/account", function(){ return i("my-phorest/templates/accounts/account.hbs");});
d("my-phorest/controllers/accounts/account", function(){ return i("my-phorest/controllers/accounts/account.js");});
d("my-phorest/routes/accounts/account", function(){ return i("my-phorest/routes/accounts/account.js");});
d("my-phorest/templates/accounts/index", function(){ return i("my-phorest/templates/accounts/index.hbs");});
d("my-phorest/routes/accounts/index", function(){ return i("my-phorest/routes/accounts/index.js");});
d("my-phorest/templates/application", function(){ return i("my-phorest/templates/application.hbs");});
d("my-phorest/controllers/application", function(){ return i("my-phorest/controllers/application.js");});
d("my-phorest/routes/application", function(){ return i("my-phorest/routes/application.js");});
d("my-phorest/templates/desktop", function(){ return i("my-phorest/templates/desktop.hbs");});
d("my-phorest/controllers/desktop", function(){ return i("my-phorest/controllers/desktop.js");});
d("my-phorest/templates/integrations", function(){ return i("my-phorest/templates/integrations.hbs");});
d("my-phorest/controllers/integrations", function(){ return i("my-phorest/controllers/integrations.js");});
d("my-phorest/templates/pin-pad", function(){ return i("my-phorest/templates/pin-pad.hbs");});
d("my-phorest/controllers/pin-pad", function(){ return i("my-phorest/controllers/pin-pad.js");});
d("my-phorest/routes/pin-pad", function(){ return i("my-phorest/routes/pin-pad.js");});
d("my-phorest/routes/index", function(){ return i("my-phorest/routes/index.js");});

  if (macroCondition(getGlobalConfig().fastboot?.isRunning)) {
d("my-phorest/instance-initializers/setup-fetch", function(){ return i("my-phorest/instance-initializers/setup-fetch.js");});
  }


w._embroiderRouteBundles_ = [
  {
    names: ["accounts.account.appointments","accounts.account.appointments.add-deposit","accounts.account.appointments.add-deposit.payment-in-progress","accounts.account.appointments.booking-history.photos","accounts.account.appointments.edit","accounts.account.appointments.edit.service","accounts.account.appointments.edit.service.swap-package","accounts.account.appointments.edit.machine","accounts.account.appointments.edit.room","accounts.account.appointments.edit.staff-member","accounts.account.appointments.group-bookings","accounts.account.appointments.group-bookings.client","accounts.account.appointments.group-bookings.service","accounts.account.appointments.group-bookings.staff-member","accounts.account.appointments.group-bookings.index","accounts.account.appointments.group-bookings.payment","accounts.account.appointments.notes","accounts.account.appointments.staff-qualification-checker","accounts.account.appointments.staff-qualification-checker.services","accounts.account.appointments.staff-qualification-checker.staff-availability","accounts.account.appointments.staff-qualification-checker.index","accounts.account.appointments.treat-card","accounts.account.appointments.breaks.edit","accounts.account.appointments.no-show.index","accounts.account.appointments.rebook"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.appointments.js");
    }
  },
  {
    names: ["accounts.account.audit-trail-breaks"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.audit-trail-breaks.js");
    }
  },
  {
    names: ["accounts.account.audit-trail"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.audit-trail.js");
    }
  },
  {
    names: ["accounts.account.cash-up-report-viewer"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.cash-up-report-viewer.js");
    }
  },
  {
    names: ["accounts.account.cash-up"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.cash-up.js");
    }
  },
  {
    names: ["accounts.account.chain-course","accounts.account.chain-course.branches","accounts.account.chain-course.create","accounts.account.chain-course.details"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-course.js");
    }
  },
  {
    names: ["accounts.account.chain-courses"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-courses.js");
    }
  },
  {
    names: ["accounts.account.chain-membership","accounts.account.chain-membership.branches","accounts.account.chain-membership.create","accounts.account.chain-membership.details","accounts.account.chain-membership.new"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-membership.js");
    }
  },
  {
    names: ["accounts.account.chain-memberships"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-memberships.js");
    }
  },
  {
    names: ["accounts.account.chain-package","accounts.account.chain-package.create","accounts.account.chain-package.branches","accounts.account.chain-package.details"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-package.js");
    }
  },
  {
    names: ["accounts.account.chain-packages"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-packages.js");
    }
  },
  {
    names: ["accounts.account.chain-product","accounts.account.chain-product.branches","accounts.account.chain-product.create","accounts.account.chain-product.details"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-product.js");
    }
  },
  {
    names: ["accounts.account.chain-products"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-products.js");
    }
  },
  {
    names: ["accounts.account.chain-special-offer.product","accounts.account.chain-special-offer.product.branches","accounts.account.chain-special-offer.product.create","accounts.account.chain-special-offer.product.details","accounts.account.chain-special-offer.service","accounts.account.chain-special-offer.service.create","accounts.account.chain-special-offer.service.branches","accounts.account.chain-special-offer.service.details"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-special-offer.product.js");
    }
  },
  {
    names: ["accounts.account.chain-special-offers","accounts.account.chain-special-offers.products","accounts.account.chain-special-offers.services","accounts.account.chain-special-offers.index"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-special-offers.js");
    }
  },
  {
    names: ["accounts.account.client-merge"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.client-merge.js");
    }
  },
  {
    names: ["accounts.account.client","accounts.account.client.booking-history","accounts.account.client.booking-history.photos","accounts.account.client.booking-history.index","accounts.account.client.booking-history.notes","accounts.account.client.communications","accounts.account.client.create","accounts.account.client.patch-tests","accounts.account.client.product-history","accounts.account.client.product-history.index","accounts.account.client.product-history.notes","accounts.account.client.treat-card","accounts.account.client.wallet","accounts.account.client.wallet.add-card","accounts.account.client.wallet.card-added","accounts.account.client.consultations-embed","accounts.account.client.consultations-embed.-base","accounts.account.client.consultations-embed.comparison","accounts.account.client.consultations-embed.forms","accounts.account.client.consultations-embed.gallery","accounts.account.client.consultations-embed.markup","accounts.account.client.consultations-embed.plans","accounts.account.client.consultations-embed.uploads","accounts.account.client.consultations","accounts.account.client.courses","accounts.account.client.form","accounts.account.client.form.app","accounts.account.client.form.app.mirror","accounts.account.client.form.app-loading","accounts.account.client.memberships","accounts.account.client.overview","accounts.account.client.photos","accounts.account.client.spend","accounts.account.client.vouchers"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.client.js");
    }
  },
  {
    names: ["accounts.account.clients","accounts.account.clients.audit-trail"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.clients.js");
    }
  },
  {
    names: ["accounts.account.commission-system","accounts.account.commission-system.create"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.commission-system.js");
    }
  },
  {
    names: ["accounts.account.commission-systems"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.commission-systems.js");
    }
  },
  {
    names: ["accounts.account.courses","accounts.account.courses.client-courses","accounts.account.courses.courses","accounts.account.courses.index"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.courses.js");
    }
  },
  {
    names: ["accounts.account.csv-export"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.csv-export.js");
    }
  },
  {
    names: ["accounts.account.custom-breaks","accounts.account.custom-breaks.edit","accounts.account.custom-breaks.create"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.custom-breaks.js");
    }
  },
  {
    names: ["accounts.account.dot-phrase-library.index","accounts.account.dot-phrase-library.edit","accounts.account.dot-phrase-library.new"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.dot-phrase-library.index.js");
    }
  },
  {
    names: ["accounts.account.fixed-discount","accounts.account.fixed-discount.create"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.fixed-discount.js");
    }
  },
  {
    names: ["accounts.account.fixed-discounts"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.fixed-discounts.js");
    }
  },
  {
    names: ["accounts.account.integrations","accounts.account.integrations.xero","accounts.account.integrations.vish"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.integrations.js");
    }
  },
  {
    names: ["accounts.account.jasper-reports","accounts.account.jasper-reports.history","accounts.account.jasper-reports.history-of-report"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.jasper-reports.js");
    }
  },
  {
    names: ["accounts.account.legacy-report-viewer"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.legacy-report-viewer.js");
    }
  },
  {
    names: ["accounts.account.manager-business"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.manager-business.js");
    }
  },
  {
    names: ["accounts.account.manager-departments","accounts.account.manager-departments.index","accounts.account.manager-departments.assign"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.manager-departments.js");
    }
  },
  {
    names: ["accounts.account.manager-petty-cash"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.manager-petty-cash.js");
    }
  },
  {
    names: ["accounts.account.marketing.client-reconnect","accounts.account.marketing.client-reconnect.index","accounts.account.marketing.client-reconnect.index.settings","accounts.account.marketing.client-reconnect.index.templates","accounts.account.marketing.client-reconnect.index.templates.category","accounts.account.marketing.client-reconnect.index.templates.category.index","accounts.account.marketing.client-reconnect.index.templates.category.template","accounts.account.marketing.client-reconnect.index.templates.index","accounts.account.marketing.client-reconnect.index.overview","accounts.account.marketing.client-reconnect.clients","accounts.account.marketing.client-reconnect.clients.status","accounts.account.marketing.lead-management-landing","accounts.account.marketing.lead-management","accounts.account.marketing.lead-management.lead-engagement","accounts.account.marketing.lead-management.lead-engagement.template","accounts.account.marketing.lead-management.leads","accounts.account.marketing.lead-management.settings","accounts.account.marketing.loyalty.referrals","accounts.account.marketing.loyalty.referrals.dashboard","accounts.account.marketing.loyalty.referrals.clients","accounts.account.marketing.loyalty.referrals.settings","accounts.account.marketing.loyalty.moments.index","accounts.account.marketing.loyalty.moments.num-of-visits","accounts.account.marketing.loyalty.referrals-landing","accounts.account.marketing.meta-ads","accounts.account.marketing.meta-ads.campaigns.list","accounts.account.marketing.meta-ads.campaigns.new","accounts.account.marketing.meta-ads.campaigns.roi","accounts.account.marketing.meta-ads.campaigns.edit","accounts.account.marketing.meta-ads.campaigns.list-loading","accounts.account.marketing.meta-ads.index","accounts.account.marketing.meta-ads.get-started","accounts.account.marketing.treatcard","accounts.account.marketing.treatcard.rewards.products","accounts.account.marketing.treatcard.rewards.products.edit","accounts.account.marketing.treatcard.rewards.products.new","accounts.account.marketing.treatcard.rewards.services","accounts.account.marketing.treatcard.rewards.services.edit","accounts.account.marketing.treatcard.rewards.services.new","accounts.account.marketing.treatcard.rewards.index","accounts.account.marketing.treatcard.index","accounts.account.marketing.treatcard.settings","accounts.account.marketing.welcome-email","accounts.account.marketing.welcome-email.email-editor","accounts.account.marketing.welcome-email.settings","accounts.account.marketing.whatsapp","accounts.account.marketing.client-export","accounts.account.marketing.client-export.audit-trail","accounts.account.marketing.tools","accounts.account.marketing.meta-ads-loading"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.marketing.client-reconnect.js");
    }
  },
  {
    names: ["accounts.account.membership","accounts.account.membership.create","accounts.account.membership.new"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.membership.js");
    }
  },
  {
    names: ["accounts.account.memberships-marketing"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.memberships-marketing.js");
    }
  },
  {
    names: ["accounts.account.memberships","accounts.account.memberships.billing","accounts.account.memberships.billing.due","accounts.account.memberships.billing.due.add-card","accounts.account.memberships.billing.failed","accounts.account.memberships.billing.failed.add-card","accounts.account.memberships.billing.success","accounts.account.memberships.client-memberships","accounts.account.memberships.memberships","accounts.account.memberships.index"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.memberships.js");
    }
  },
  {
    names: ["accounts.account.order","accounts.account.order.create","accounts.account.order.add-items"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.order.js");
    }
  },
  {
    names: ["accounts.account.orders"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.orders.js");
    }
  },
  {
    names: ["accounts.account.package","accounts.account.package.create"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.package.js");
    }
  },
  {
    names: ["accounts.account.packages"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.packages.js");
    }
  },
  {
    names: ["accounts.account.payroll-reports","accounts.account.payroll-reports.business","accounts.account.payroll-reports.business.index","accounts.account.payroll-reports.business.new","accounts.account.payroll-reports.business.report","accounts.account.payroll-reports.index","accounts.account.payroll-reports.new","accounts.account.payroll-reports.report"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.payroll-reports.js");
    }
  },
  {
    names: ["accounts.account.product","accounts.account.product.create","accounts.account.product.details","accounts.account.product.history"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.product.js");
    }
  },
  {
    names: ["accounts.account.products","accounts.account.products.audit-trail"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.products.js");
    }
  },
  {
    names: ["accounts.account.purchase","accounts.account.purchase.basket","accounts.account.purchase.basket.add-card","accounts.account.purchase.basket.client.new","accounts.account.purchase.basket.notes","accounts.account.purchase.basket.payment-completed","accounts.account.purchase.basket.payment-in-progress","accounts.account.purchase.basket.payment-methods","accounts.account.purchase.basket.payment-methods.add-tip","accounts.account.purchase.basket.payment-methods.use-voucher","accounts.account.purchase.basket.client-rewards-slide-over","accounts.account.purchase.basket.petty-cash.new","accounts.account.purchase.basket.product-history","accounts.account.purchase.basket.select-client","accounts.account.purchase.new","accounts.account.purchase.new.client.new","accounts.account.purchase.new.select-client","accounts.account.purchase.new.petty-cash.new","accounts.account.purchase.receipt","accounts.account.purchase.create-basket","accounts.account.purchase.create-basket-loading"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.purchase.js");
    }
  },
  {
    names: ["accounts.account.sales","accounts.account.sales.petty-cash","accounts.account.sales.petty-cash.edit","accounts.account.sales.petty-cash.new","accounts.account.sales.till-floats","accounts.account.sales.till-transactions","accounts.account.sales.index"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.sales.js");
    }
  },
  {
    names: ["accounts.account.settings.client-notifications","accounts.account.settings.client-notifications.appointment-confirmation","accounts.account.settings.client-notifications.appointment-confirmation.settings","accounts.account.settings.client-notifications.appointment-confirmation.template","accounts.account.settings.client-notifications.appointment-reminder","accounts.account.settings.client-notifications.appointment-reminder.reminder-history","accounts.account.settings.client-notifications.appointment-reminder.template","accounts.account.settings.client-notifications.appointment-reminder.settings","accounts.account.settings.client-notifications.care-instructions","accounts.account.settings.client-notifications.care-instructions.index","accounts.account.settings.client-notifications.care-instructions.edit","accounts.account.settings.client-notifications.care-instructions.new","accounts.account.settings.client-notifications.index","accounts.account.settings.client-notifications.manual-reminders","accounts.account.settings.client-notifications.no-show","accounts.account.settings.client-notifications.no-show.template","accounts.account.settings.client-notifications.no-show.settings","accounts.account.settings.client-notifications.rebook-appointment","accounts.account.settings.client-notifications.rebook-appointment.sms","accounts.account.settings.client-notifications.rebook-appointment.settings","accounts.account.settings.client-notifications.treatcard-referral","accounts.account.settings.client-notifications.treatcard-referral.sms","accounts.account.settings.client-notifications.treatcard-referral.settings"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.settings.client-notifications.js");
    }
  },
  {
    names: ["accounts.account.special-offer.product","accounts.account.special-offer.product.create","accounts.account.special-offer.service","accounts.account.special-offer.service.create"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.special-offer.product.js");
    }
  },
  {
    names: ["accounts.account.special-offers","accounts.account.special-offers.products","accounts.account.special-offers.services","accounts.account.special-offers.index"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.special-offers.js");
    }
  },
  {
    names: ["accounts.account.stock-take"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.stock-take.js");
    }
  },
  {
    names: ["accounts.account.stock-takes"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.stock-takes.js");
    }
  },
  {
    names: ["accounts.account.stock-transfer"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.stock-transfer.js");
    }
  },
  {
    names: ["accounts.account.stock-transfers","accounts.account.stock-transfers.incoming","accounts.account.stock-transfers.outgoing","accounts.account.stock-transfers.index"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.stock-transfers.js");
    }
  },
  {
    names: ["accounts.account.supplier","accounts.account.supplier.create"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.supplier.js");
    }
  },
  {
    names: ["accounts.account.suppliers"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.suppliers.js");
    }
  },
  {
    names: ["accounts.account.tax-rate","accounts.account.tax-rate.create"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.tax-rate.js");
    }
  },
  {
    names: ["accounts.account.tax-rates","accounts.account.tax-rates.product","accounts.account.tax-rates.service","accounts.account.tax-rates.index","accounts.account.tax-rates.prepaid"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.tax-rates.js");
    }
  },
  {
    names: ["accounts.account.vouchers","accounts.account.vouchers.client-vouchers","accounts.account.vouchers.voucher-campaigns","accounts.account.vouchers.index"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.vouchers.js");
    }
  },
  {
    names: ["accounts.account.cash-up-report"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.cash-up-report.js");
    }
  },
  {
    names: ["accounts.account.chain-settings"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.chain-settings.js");
    }
  },
  {
    names: ["accounts.account.client-course","accounts.account.client-course.create","accounts.account.client-course.details","accounts.account.client-course.history"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.client-course.js");
    }
  },
  {
    names: ["accounts.account.client-membership","accounts.account.client-membership.create","accounts.account.client-membership.details","accounts.account.client-membership.history"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.client-membership.js");
    }
  },
  {
    names: ["accounts.account.client-voucher","accounts.account.client-voucher.create","accounts.account.client-voucher.details","accounts.account.client-voucher.history"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.client-voucher.js");
    }
  },
  {
    names: ["accounts.account.consultation-form-templates","accounts.account.consultation-form-templates.index","accounts.account.consultation-form-templates.service-list","accounts.account.consultation-form-templates.template-list"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.consultation-form-templates.js");
    }
  },
  {
    names: ["accounts.account.course","accounts.account.course.create"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.course.js");
    }
  },
  {
    names: ["accounts.account.embed","accounts.account.embed.app","accounts.account.embed.app.mirror","accounts.account.embed.app-loading"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.embed.js");
    }
  },
  {
    names: ["accounts.account.index"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.index.js");
    }
  },
  {
    names: ["accounts.account.manager-chain-library"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.manager-chain-library.js");
    }
  },
  {
    names: ["accounts.account.manager"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.manager.js");
    }
  },
  {
    names: ["accounts.account.payment-link","accounts.account.payment-link.settings"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.payment-link.js");
    }
  },
  {
    names: ["accounts.account.print.appointment-client-travel-card","accounts.account.print.appointment-reminder","accounts.account.print.client-quote","accounts.account.print.columns","accounts.account.print.selected-note","accounts.account.print.voucher-receipt"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.print.appointment-client-travel-card.js");
    }
  },
  {
    names: ["accounts.account.reports"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.reports.js");
    }
  },
  {
    names: ["accounts.account.stock-take-report-viewer"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.stock-take-report-viewer.js");
    }
  },
  {
    names: ["accounts.account.voucher-campaign","accounts.account.voucher-campaign.create","accounts.account.voucher-campaign.details"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.voucher-campaign.js");
    }
  },
  {
    names: ["accounts.account.brand-settings"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.brand-settings.js");
    }
  },
  {
    names: ["accounts.account.feature-flags"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.feature-flags.js");
    }
  },
  {
    names: ["accounts.account.manager-categories"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.manager-categories.js");
    }
  },
  {
    names: ["accounts.account.manager-chart-of-accounts","accounts.account.manager-chart-of-accounts.configuration","accounts.account.manager-chart-of-accounts.settings"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.manager-chart-of-accounts.js");
    }
  },
  {
    names: ["accounts.account.manager-consultations"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.manager-consultations.js");
    }
  },
  {
    names: ["accounts.account.noaccess"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.noaccess.js");
    }
  },
  {
    names: ["accounts.account.printing-devices"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.printing-devices.js");
    }
  },
  {
    names: ["accounts.account.voucher-loading"],
    load: function() {
      return import("my-phorest/assets/_route_/accounts.account.voucher-loading.js");
    }
  },
  {
    names: ["forgot-password"],
    load: function() {
      return import("my-phorest/assets/_route_/forgot-password.js");
    }
  },
  {
    names: ["login"],
    load: function() {
      return import("my-phorest/assets/_route_/login.js");
    }
  },
  {
    names: ["pgo","pgo.fbe-auth","pgo.login"],
    load: function() {
      return import("my-phorest/assets/_route_/pgo.js");
    }
  },
  {
    names: ["planner","planner.appointment.graphql","planner.availability","planner.booking-history","planner.booking-history.photos","planner.clients","planner.edit-booking-intent","planner.services","planner.staff-members.graphql","planner.staff","planner.index"],
    load: function() {
      return import("my-phorest/assets/_route_/planner.js");
    }
  },
  {
    names: ["reset-password"],
    load: function() {
      return import("my-phorest/assets/_route_/reset-password.js");
    }
  },
  {
    names: ["waitlist","waitlist.booking","waitlist.booking.add-service","waitlist.booking.index","waitlist.booking.select-staff","waitlist.index","waitlist.new"],
    load: function() {
      return import("my-phorest/assets/_route_/waitlist.js");
    }
  },
  {
    names: ["auto-login-v1"],
    load: function() {
      return import("my-phorest/assets/_route_/auto-login-v1.js");
    }
  },
  {
    names: ["auto-login-v2"],
    load: function() {
      return import("my-phorest/assets/_route_/auto-login-v2.js");
    }
  },
  {
    names: ["client-membership-terms","client-membership-terms.index","client-membership-terms.success"],
    load: function() {
      return import("my-phorest/assets/_route_/client-membership-terms.js");
    }
  },
  {
    names: ["customer-children"],
    load: function() {
      return import("my-phorest/assets/_route_/customer-children.js");
    }
  },
  {
    names: ["customer"],
    load: function() {
      return import("my-phorest/assets/_route_/customer.js");
    }
  },
  {
    names: ["download"],
    load: function() {
      return import("my-phorest/assets/_route_/download.js");
    }
  },
  {
    names: ["logout"],
    load: function() {
      return import("my-phorest/assets/_route_/logout.js");
    }
  },
  {
    names: ["404"],
    load: function() {
      return import("my-phorest/assets/_route_/404.js");
    }
  },
]


if (!runningTests) {
  i("../app").default.create({"UNSPECIFIED_REVISION_KEY":"local-development-no-revision-key-specified","apiGatewayEU":"https://api-gateway-eu.phorest.com","apiGatewayUS":"https://api-gateway-us.phorest.com","authServiceURL":"https://api-gateway-eu.phorest.com/auth/oauth","deployRevision":"fca12c92d70b68b1a6e1d0f12411f5a2266a667b","onlineBookingRootURL":"https://phorest.com/book/salons","onlineBookingBranchPickerURL":"https://$DOMAIN_NAME.phorest.me/locations","phorestCloudEU":"https://prod.phorest.com","isRunningWithServerArgs":false,"name":"my-phorest","version":"1.55.0+fca12c92"});
}

